import CustomTable from "../../ui/CustomTable";
import FilterForm from "./FilterForm";
import { Alert, Typography } from "@mui/material";
import { useReservation } from "./provider";
import TabsList from "../../ui/TabsList";
import { useState } from "react";
import EndDate from "./Render/EndDate";
import StartDate from "./Render/StartDate";
import { FilterFields } from "./Fields";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import ErrorsList from "../../ui/ErrorsList";
import { useAuth } from "../../services/auth";
import { useSite } from "../Sites/Provider";
import { useSubCompany } from "../SubCompanies/Provider";

// yup schema
const yupSchema = FilterFields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);
const ListReservation = () => {
  const navigate = useNavigate();
  const { role } = useAuth();
  const {
    state: { companyId, list, page, perPage, count, length },
    dispatch,
    remove,
  } = useReservation();
  const {
    state: { selected: siteInfo },
  } = useSite();
  const {
    state: { selected: SubCompany },
  } = useSubCompany();
  const form = useForm({
    resolver: yupResolver(formSchema),
  });
  const tabs = [{ title: "Reservations", num: length }];
  const [selectedCols, setSelectedCols] = useState("Reservations");
  const [error, setError] = useState();

  const changePageSize = (size) => {
    dispatch({ type: "set_per_page", payload: size });
  };

  const cols = [
    {
      label: "Title",
      name: "title",
      headTextLeft: true,
      textLeft: true,
    },
    {
      label: "Start Date",
      name: "startDate",
      customRender: StartDate,
    },
    {
      label: "End Date",
      name: "endDate",
      customRender: EndDate,
    },
    {
      label: "Number of People",
      name: "number",
    },
  ];

  const handleDelete = (id) => {
    try {
      remove(id);
    } catch (error) {
      setError({ title: error.errors.message });
      console.error(error, "error");
    }
  };

  return (
    <>
      <Typography variant="Poster" component="h4" mb={2}>
        Select Company and Site
      </Typography>
      {error && (
        <Alert severity="error" sx={{ m: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      )}
      <FilterForm />
      <TabsList
        tabs={tabs}
        setSelectedCols={setSelectedCols}
        selectedCols={selectedCols}
      />
      <CustomTable
        empty={list?.length === 0 ? true : false}
        cols={cols}
        data={list || []}
        filters={{
          pagination: true,
          page: perPage,
          changePageSize: changePageSize,
          add:
            role !== "SubCompany" &&
            (() => {
              if (role === "Admin" || role === "Company") {
                if (companyId) {
                  navigate("add/" + companyId);
                  setError();
                } else {
                  setError({ title: "You must select company at first" });
                }
              } else if (role === "Site") {
                if (siteInfo?.company?.id) {
                  navigate("add/" + siteInfo?.company?.id);
                  setError();
                } else {
                  setError({ title: "Company information not available" });
                }
              }
            }),
        }}
        actions={{
          edit:
            role !== "SubCompany" &&
            ((id) => {
              if (companyId && role !== "Site") {
                navigate("edit/" + companyId + "/" + id);
              } else if (role === "Site") {
                navigate("edit/" + siteInfo?.company?.id + "/" + id);
              } else {
                setError({ title: "You must select company at first" });
              }
            }),
          delete:
            role !== "SubCompany" &&
            ((id) => {
              handleDelete(id);
            }),
        }}
        rowsPerPage={10}
        dispatch={dispatch}
        count={count}
        page={page}
        isPagination={true}
      ></CustomTable>
    </>
  );
};

export default ListReservation;
